import React, { useEffect, useState } from "react";
import {
  Input,
  Row,
  Col,
  Form,
  // message,
  Button,
  Modal,
  message,
  Upload,
  DatePicker,
  Select,
  Checkbox,
  Spin,
} from "antd";
import API_MANAGER from "../../../API";
import DocumentBox from "../../../components/common/DocumentBox";
import {
  EditFilled,
  MinusOutlined,
  PlusOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { s3PreUrl } from "../../../constants";
import axios from "axios";
import dayjs from "dayjs";
function AdditionalDetailEdit({
  data,
  additionalEdit,
  setAdditionalEdit,
  userId,
  certifyingAuthority,
  stateTags,
  fundName,
  shirt,
  pants,
  boots,
}) {
  const [additionEditForm] = Form.useForm();
  const [editDocument, setEditDocument] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [isSuperannuation, setIsSuperannuation] = useState(
    data?.isSuperannuation
  );
  const [isLSL, setIsLSL] = useState(data?.isLSL);
  const [hasTravelDetails, setHasTravelDetails] = useState(
    data?.hasTravelDetails
  );
  const [isPPE, setIsPPE] = useState(data?.isPPE);
  const [hasPoliceClearance, setHasPoliceClearance] = useState(
    data?.hasPoliceClearance
  );
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const addRow = () => {
    setRows((prevRows) => [
      ...prevRows,
      {
        state: { name: "", id: "" }, // Empty state values for new row
        memberNumber: "",
      },
    ]);
  };
  useEffect(() => {
    if (data?.lslDetails && data.lslDetails.length > 0) {
      const transformedArray = data.lslDetails.map(
        ({ state, memberNumber }) => ({
          state: { name: state.name, id: state.id },
          memberNumber,
        })
      );
      setRows(transformedArray);
    } else if (isLSL) {
      setRows((prevRows) => {
        if (prevRows.length === 0) {
          return [{
            state: { name: "", id: "" },
            memberNumber: "",
          }];
        }
        return prevRows;
      });
    }
  }, [data, isLSL]);
  const props = {
    name: "file",
    accept: "image/jpg,image/jpeg,.pdf",
    multiple: false,
    customRequest({ onSuccess }) {
      setTimeout(() => {
        onSuccess("ok");
      }, 0);
    },
    onChange(info) {
      const { status } = info.file;
      if (status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (status === "done") {
        message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },
  };
  const handleUpload = ({ fileList: newFileList }) => {
    setFileList(newFileList);
  };
  const handleFinish = async (values) => {
    // This function only runs if validation passes
    // If validation fails, onFinishFailed will be called instead
    console.log("values: ", values);
    setLoading(true);

    try {
      // Validate LSL details if checked
      if (isLSL) {
        const hasInvalidRow = rows.some(
          ({ state }) => !state.id
        );
        if (hasInvalidRow) {
          message.error("Please select State for all entries.");
          setLoading(false);
          return; // Prevent submission
        }
      }

      let responseDocument = null;
      if (hasPoliceClearance && fileList?.length > 0 && fileList[0]?.originFileObj) {
        const dataDocument = {
          extension: fileList[0]?.type.split("/")[1],
          type: "DOCUMENT",
          name: fileList[0].originFileObj.name,
          contentType: fileList[0]?.type,
        };
        responseDocument = await API_MANAGER.fileUpload(dataDocument);
        await axios.put(
          responseDocument?.data?.data?.url,
          fileList[0]?.originFileObj
        );
      }

      values.userId = userId;
      let objData = {
        userId: values?.userId,
        tfnNo: values?.tfnNo,
        usiNo: values?.usiNo,
        isSuperannuation: isSuperannuation,
        isLSL: isLSL,
        isPPE: isPPE,
        hasTravelDetails: hasTravelDetails,
        hasPoliceClearance: hasPoliceClearance,
      };

      if (isSuperannuation) {
        const existingFundNameId = data?.superannuationDetails?.fundName?.id || data?.superannuationDetails?.fundName;
        const fundNameChanged = String(existingFundNameId) !== String(values.fundName);
        
        let fundUsiAbnId = null;
        
        if (fundNameChanged && values.fundName) {
          const selectedFund = fundName?.find((e) => e.id === values.fundName);
          if (selectedFund?.correspondingValue) {
            fundUsiAbnId = typeof selectedFund.correspondingValue === 'object'
              ? selectedFund.correspondingValue._id || selectedFund.correspondingValue.id
              : selectedFund.correspondingValue;
          }
        } else {
          const existingFundUsiAbn = data?.superannuationDetails?.fundUsiAbn;
          if (existingFundUsiAbn) {
            fundUsiAbnId = typeof existingFundUsiAbn === 'object'
              ? existingFundUsiAbn._id || existingFundUsiAbn.id
              : existingFundUsiAbn;
          }
        }
        
        if (!fundUsiAbnId && values.fundUsiAbn) {
          fundUsiAbnId = typeof values.fundUsiAbn === 'object'
            ? values.fundUsiAbn._id || values.fundUsiAbn.id
            : values.fundUsiAbn;
        }
        
        if (!fundUsiAbnId && values.fundName) {
          const selectedFund = fundName?.find((e) => e.id === values.fundName);
          if (selectedFund?.correspondingValue) {
            fundUsiAbnId = typeof selectedFund.correspondingValue === 'object'
              ? selectedFund.correspondingValue._id || selectedFund.correspondingValue.id
              : selectedFund.correspondingValue;
          }
        }
        
        if (!fundUsiAbnId) {
          message.error("Fund USI/ABN is required. Please select a fund name.");
          setLoading(false);
          return;
        }
        
        fundUsiAbnId = String(fundUsiAbnId).trim();
        
        if (!fundUsiAbnId.match(/^[0-9a-fA-F]{24}$/)) {
          message.error("Fund USI/ABN must be a valid MongoDB ID. Please select a fund name.");
          setLoading(false);
          return;
        }
        
        objData.superannuationDetails = {
          fundName: values.fundName,
          fundUsiAbn: fundUsiAbnId,
          memberNumber: values.fundMemberNumber,
        };
      }

      if (isLSL) {
        if (rows.length === 0) {
          message.error("Please add at least one Long Service Leave entry");
          setLoading(false);
          return;
        }
        
        for (let i = 0; i < rows.length; i++) {
          const row = rows[i];
          if (!row.state || !row.state.id) {
            message.error(`Please select state for entry ${i + 1}`);
            setLoading(false);
            return;
          }
        }
        
        objData.lslDetails = rows.map(({ state, memberNumber }) => ({
          state: state.id,
          memberNumber,
        }));
      }

      if (isPPE) {
        objData.ppeDetails = {
          shirt: values.shirt,
          pants: values.pants,
          boots: values.boots,
        };
      }

      console.log("dddddddd", objData, values);
      if (hasTravelDetails) {
        objData.travelDetails = {
          preferredAirline: values.preferredAirline,
          frequentFlyerNumber: values.frequentFlyerNumber,
        };
      }

      if (hasPoliceClearance) {
        objData.policeClearanceDetails = {
          document:
            fileList?.length > 0
              ? s3PreUrl + responseDocument.data?.data?.key
              : data?.policeClearanceDetails?.document,
          certifyingAuthority: values.certifyingAuthority,
          issueDate: values?.issueDate,
        };
      } else {
        objData.policeClearanceDetails = null;
      }

      console.log("pppppppppp", objData);
      await API_MANAGER.editCandidateAdditionalDetails(objData);
      message.success("Successfully edited additional details");
      setLoading(false);
      setAdditionalEdit(false);
    } catch (error) {
      // This is a backend error
      message.error(error.response?.data?.message?.message || "Error occurred");
    } finally {
      setLoading(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Form validation failed:', errorInfo);
    console.log('Error fields:', errorInfo.errorFields);
    // The validation messages will automatically appear below the fields
    // No API call will be made
    message.error('Please fill in all mandatory fields');
  };

  console.log("data", data);
  const setFields = () => {
    const fundNameId = data?.superannuationDetails?.fundName?.id || data?.superannuationDetails?.fundName;
    let fundUsiAbnId = data?.superannuationDetails?.fundName?.correspondingValue;
    
    if (fundUsiAbnId && typeof fundUsiAbnId === 'object') {
      fundUsiAbnId = fundUsiAbnId._id || fundUsiAbnId.id;
    }
    
    if (!fundUsiAbnId && fundNameId) {
      const existingFund = fundName?.find((e) => e.id === fundNameId);
      if (existingFund?.correspondingValue) {
        fundUsiAbnId = typeof existingFund.correspondingValue === 'object'
          ? existingFund.correspondingValue._id || existingFund.correspondingValue.id
          : existingFund.correspondingValue;
      }
    }
    
    if (!fundUsiAbnId) {
      const fundUsiAbnData = data?.superannuationDetails?.fundUsiAbn;
      fundUsiAbnId = typeof fundUsiAbnData === 'object'
        ? fundUsiAbnData._id || fundUsiAbnData.id
        : fundUsiAbnData;
    }
    
    additionEditForm.setFieldsValue({
      tfnNo: data?.tfnNo,
      usiNo: data?.usiNo,
      fundName: fundNameId,
      fundUsiAbn: fundUsiAbnId,
      certifyingAuthority:
        data?.policeClearanceDetails?.certifyingAuthority?._id,
      fundMemberNumber: data?.superannuationDetails?.memberNumber,
      state: data?.lslDetails?.state,
      memberNumber: data?.lslDetails?.memberNumber,
      pants: data?.ppeDetails?.pants?.id,
      shirt: data?.ppeDetails?.shirt?.id,
      boots: data?.ppeDetails?.boots?.id,
      frequentFlyerNumber: data?.travelDetails?.frequentFlyerNumber,
      preferredAirline: data?.travelDetails?.preferredAirline,
      issueDate: data?.policeClearanceDetails?.issueDate
        ? dayjs(data?.policeClearanceDetails?.issueDate)
        : null,
    });
  };
  useEffect(() => {
    if (data && fundName) {
      setFields();
    }
  }, [data, fundName]);
  const handleChange = (index, field, value) => {
    const updatedRows = [...rows];
    if (field === "state") {
      const selectedState = stateTags.find((e) => e.id === value);
      updatedRows[index].state = { name: selectedState?.name || "", id: value };
    } else {
      updatedRows[index].memberNumber = value;
    }
    setRows(updatedRows);
  };
  const handleFundNameChange = (value) => {
    const selectedFund = fundName?.find((e) => e.id === value);
    if (selectedFund?.correspondingValue) {
      const fundUsiAbnId = typeof selectedFund.correspondingValue === 'object' 
        ? selectedFund.correspondingValue._id || selectedFund.correspondingValue.id
        : selectedFund.correspondingValue;
      additionEditForm.setFieldsValue({
        fundUsiAbn: fundUsiAbnId,
      });
    } else {
      additionEditForm.setFieldsValue({
        fundUsiAbn: null,
      });
    }
  };
  const removeRow = (index) => {
    setRows((prevRows) => {
      const newRows = prevRows.filter((_, i) => i !== index);
      if (newRows.length === 0 && isLSL) {
        return [{
          state: { name: "", id: "" },
          memberNumber: "",
        }];
      }
      return newRows;
    });
  };
  return (
    <Modal
      centered
      footer={false}
      open={additionalEdit}
      title={"Additional Personal Details Edit"}
      className="resumeModal"
      onCancel={() => setAdditionalEdit(false)}
    >
      <Form 
        form={additionEditForm} 
        layout="vertical" 
        onFinish={handleFinish}
        onFinishFailed={onFinishFailed}
        validateTrigger="onSubmit"
      >
        <Spin spinning={loading} />
        <Row gutter={24}>
          <Col xs={12}>
            <Form.Item 
              label="Tax File Number (TFN)" 
              name="tfnNo"
              rules={[
                {
                  required: true,
                  message: "Please enter Tax File Number",
                },
              ]}
            >
              <Input placeholder="Tax File Number (TFN)" />
            </Form.Item>
          </Col>
          <Col xs={12}>
            <Form.Item 
              label="USI No." 
              name="usiNo"
              rules={[
                {
                  required: true,
                  message: "Please enter USI Number",
                },
              ]}
            >
              <Input placeholder="USI No." />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col xs={24}>
            <Checkbox
              checked={isSuperannuation}
              onChange={() => setIsSuperannuation(!isSuperannuation)}
              className="title"
            >
              Superannuation
            </Checkbox>
          </Col>
        </Row>
        {isSuperannuation && (
          <>
            {" "}
            <Row gutter={24}>
              <Col xs={12}>
                <Form.Item 
                  label="Fund Name" 
                  name="fundName"
                  rules={[
                    {
                      required: isSuperannuation,
                      message: "Please select fund name",
                    },
                  ]}
                >
                  <Select 
                    className="" 
                    placeholder="Fund Name"
                    onChange={handleFundNameChange}
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {fundName?.map((e, key) => {
                      return (
                        <Select.Option key={key} value={e?.id}>
                          {e?.name}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={12}>
                <Form.Item 
                  label="Member Number" 
                  name="fundMemberNumber"
                  rules={[
                    {
                      required: isSuperannuation,
                      message: "Please enter member number",
                    },
                  ]}
                >
                  <Input placeholder="Member Number" />
                </Form.Item>
              </Col>
            </Row>
            <Form.Item name="fundUsiAbn" hidden>
              <Input />
            </Form.Item>
          </>
        )}
        <Row>
          <Col xs={24}>
            <Checkbox
              checked={isLSL}
              onChange={(e) => {
                const checked = e.target.checked;
                setIsLSL(checked);
                if (checked && rows.length === 0) {
                  setRows([{
                    state: { name: "", id: "" },
                    memberNumber: "",
                  }]);
                } else if (!checked) {
                  setRows([]);
                }
              }}
              className="title"
            >
              Long Service Leave
            </Checkbox>
          </Col>
        </Row>
        {isLSL && (
          <>
            {rows.map((row, index) => (
              <Row key={index} gutter={[16, 16]} align="middle">
                <Col xs={10}>
                  <Form.Item 
                    label="State*"
                    requiredMark={false}
                    validateStatus={!row.state || !row.state.id ? "error" : ""}
                    help={!row.state || !row.state.id ? "Please select state" : ""}
                  >
                    <Select
                      value={row.state.id || undefined}
                      placeholder="State"
                      onChange={(value) => handleChange(index, "state", value)}
                    >
                      {stateTags?.map((e) => (
                        <Select.Option key={e.id} value={e.id}>
                          {e.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={10}>
                  <Form.Item 
                    label="Member Number"
                    requiredMark={false}
                  >
                    <Input
                      value={row.memberNumber}
                      placeholder="Member Number"
                      onChange={(e) =>
                        handleChange(index, "memberNumber", e.target.value)
                      }
                    />
                  </Form.Item>
                </Col>
                <Col xs={2}>
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={addRow}
                  />
                </Col>
                <Col xs={2}>
                  <Button
                    type="danger"
                    icon={<MinusOutlined />}
                    onClick={() => removeRow(index)}
                  />
                </Col>
              </Row>
            ))}
          </>
        )}
        <Row>
          <Col xs={24}>
            <Checkbox
              checked={isPPE}
              onChange={() => setIsPPE(!isPPE)}
              className="title"
            >
              PPE Details
            </Checkbox>
          </Col>
        </Row>
        {isPPE && (
          <Row gutter={24}>
            <Col xs={8}>
              <Form.Item 
                label="Shirt" 
                name="shirt"
                rules={[
                  {
                    required: isPPE,
                    message: "Please select shirt",
                  },
                ]}
              >
                <Select className="" placeholder="Shirt">
                  {shirt?.map((e, key) => {
                    return (
                      <Select.Option key={key} value={e?._id}>
                        {e?.name}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={8}>
              <Form.Item 
                label="Pants" 
                name="pants"
                rules={[
                  {
                    required: isPPE,
                    message: "Please select pants",
                  },
                ]}
              >
                <Select className="" placeholder="Pants">
                  {pants?.map((e, key) => {
                    return (
                      <Select.Option key={key} value={e?._id}>
                        {e?.name}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={8}>
              <Form.Item 
                label="Boots" 
                name="boots"
                rules={[
                  {
                    required: isPPE,
                    message: "Please select boots",
                  },
                ]}
              >
                <Select className="" placeholder="Boots">
                  {boots?.map((e, key) => {
                    return (
                      <Select.Option key={key} value={e?._id}>
                        {e?.name}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        )}
        <Row>
          <Col xs={24}>
            <Checkbox
              checked={hasTravelDetails}
              onChange={() => setHasTravelDetails(!hasTravelDetails)}
              className="title"
            >
              Travel Details
            </Checkbox>
          </Col>
        </Row>
        {hasTravelDetails && (
          <Row gutter={24}>
            <Col xs={12}>
              <Form.Item 
                label="Preferred Airline" 
                name="preferredAirline"
                rules={[
                  {
                    required: hasTravelDetails,
                    message: "Please enter preferred airline",
                  },
                ]}
              >
                <Input placeholder="Preferred Airline" />
              </Form.Item>
            </Col>
            <Col xs={12}>
              <Form.Item
                label="Frequent Flyer Number"
                name="frequentFlyerNumber"
                rules={[
                  {
                    required: hasTravelDetails,
                    message: "Please enter frequent flyer number",
                  },
                ]}
              >
                <Input placeholder="Frequent Flyer Number" />
              </Form.Item>
            </Col>
          </Row>
        )}
        <Row>
          <Col xs={24}>
            <Checkbox
              checked={hasPoliceClearance}
              onChange={() => setHasPoliceClearance(!hasPoliceClearance)}
              className="title"
            >
              Police Clearance
            </Checkbox>
          </Col>
        </Row>
        {hasPoliceClearance && (
          <>
            <Row>
              <Col xs={18}>
                {editDocument || !data?.policeClearanceDetails?.document ? (
                  <Upload {...props} onChange={handleUpload}>
                    <Button icon={<UploadOutlined />}>Upload</Button>
                  </Upload>
                ) : (
                  <DocumentBox
                    date={data?.policeClearanceDetails?.issueDate}
                    url={data?.policeClearanceDetails?.document}
                  />
                )}
              </Col>
              {data?.policeClearanceDetails?.document && !editDocument && (
                <Col className="editResume" xs={6}>
                  <EditFilled onClick={() => setEditDocument(true)} />
                </Col>
              )}
            </Row>
            <Row gutter={24}>
              <Col xs={12}>
                <Form.Item
                  label="Certifying Authority"
                  name="certifyingAuthority"
                  rules={[
                    {
                      required: hasPoliceClearance,
                      message: "Please select certifying authority",
                    },
                  ]}
                >
                  <Select className="" placeholder="Certifying Authority">
                    {certifyingAuthority?.map((e, key) => {
                      return (
                        <Select.Option key={key} value={e?.id}>
                          {e?.name}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={12}>
                <Form.Item 
                  label="Issue Date" 
                  name="issueDate"
                  rules={[
                    {
                      required: hasPoliceClearance,
                      message: "Please select issue date",
                    },
                  ]}
                >
                  <DatePicker
                    className="w-100"
                    format={"DD-MM-YYYY"}
                    placeholder="Select issue date"
                  />
                </Form.Item>
              </Col>
            </Row>
          </>
        )}
        <Row>
          <Col xs={24} className="buttonCol">
            <Button className="btn1" htmlType="submit">
              Update
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
export default AdditionalDetailEdit;
